import {composeReducers} from 'common/util/composeReducers';

import {
    APPLICATION_MESSAGE_ADD,
    APPLICATION_MESSAGE_ADDMANY,
    APPLICATION_MESSAGE_REMOVE,
    APPLICATION_MESSAGE_REMOVE_ALL,
} from 'common/actions/applicationMessagesActions';

export function addApplicationMessage(state, action) {
    if (!action || action.type !== APPLICATION_MESSAGE_ADD) {
        return state;
    }

    const {id, type, message, messageData} = action.payload;
    const newMessage = {
        id,
        type,
        message,
        messageData
    };

    const messages = {...state.messages};
    messages[newMessage.id] = newMessage;
    return {
        ...state,
        messages
    };
}

export function addApplicationMessages(state, action) {
    if (!action || action.type !== APPLICATION_MESSAGE_ADDMANY) {
        return state;
    }

    const messages = action.payload;

    const newMessages = {...messages, ...state.messages};
    return {
        ...state,
        messages: newMessages
    };
}

export function removeApplicationMessages(state, action) {
    if (!action || action.type !== APPLICATION_MESSAGE_REMOVE) {
        return state;
    }

    const messageId = action.payload;

    const messages = {...state.messages};
    delete messages[messageId];

    return {
        ...state,
        messages
    };
}

export function clearApplicationMessages(state, action) {
    if (!action || action.type !== APPLICATION_MESSAGE_REMOVE_ALL) {
        return state;
    }

    return {
        ...state,
        messages: []
    };
}

export default composeReducers(
    addApplicationMessage,
    addApplicationMessages,
    removeApplicationMessages,
    clearApplicationMessages
);